import React, { useEffect, useState } from 'react';
import axios from 'axios';
import logo from './images/center-images.png'; 
import './App.css'; 

function App() {
  // 화면 전환을 위한 상태 (main: 메인홈, cheonan: 천안매물목록)
  const [view, setView] = useState("main");
  const [cheonanList, setCheonanList] = useState([]);

  // 🔎 [추가] 검색어 상태 변수 4개와 초기화용 변수
  const [searchSite, setSearchSite] = useState("");     // 현장명 (드롭다운)
  const [searchManager, setSearchManager] = useState(""); // 담당자 (드롭다운)
  const [searchDong, setSearchDong] = useState("");       // 동 (입력창)
  const [searchHo, setSearchHo] = useState("");         // 호수 (입력창)

  // 💡 [추가] 드롭다운 메뉴용 데이터 추출 (중복 제거)
  const uniqueSites = [...new Set(cheonanList.map(item => item.siteName).filter(Boolean))];
  const uniqueManagers = [...new Set(cheonanList.map(item => item.manager).filter(Boolean))];

  // ⚡ [추가] 입력값이 바뀔 때마다 자동으로 걸러주는 실시간 필터링 로직
  const filteredList = cheonanList.filter(item => {
    const matchSite = searchSite === "" || item.siteName === searchSite;
    const matchManager = searchManager === "" || item.manager === searchManager;
    const matchDong = searchDong === "" || (item.dong && item.dong.includes(searchDong));
    const matchHo = searchHo === "" || (item.ho && item.ho.includes(searchHo));
    
    return matchSite && matchManager && matchDong && matchHo;
  });

  // 🔄 [추가] 초기화 함수
  const resetSearch = () => {
    setSearchSite(""); setSearchManager(""); setSearchDong(""); setSearchHo("");
  };

  // 천안 매물 데이터를 백엔드에서 받아오는 함수
  const fetchCheonanData = () => {
    // ⚠️ 본인 컴퓨터의 IPv4 주소로 변경하세요!
    // axios.get('http://172.30.1.6:8080/api/cheonan')
    axios.get('http://jimmykim9.synology.me:8080/api/cheonan')
      .then(response => {
        setCheonanList(response.data);
        setView("cheonan"); // 데이터를 다 가져오면 천안 페이지로 이동
      })
      .catch(error => console.error("데이터 로딩 실패:", error));
  };

  return (
    <div className="App" style={{ backgroundColor: '#f5f6fa', minHeight: '100vh', padding: '20px' }}>
      
      {/* 1. 메인 홈페이지 뷰 */}
      {view === "main" && (
        <header style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '50px' }}>
          <img src={logo} style={{ height: '180px', marginBottom: '20px' }} alt="중앙부동산 로고" />
          <h1 style={{ color: '#2c3e50', marginBottom: '40px' }}>중앙부동산 매물관리시스템</h1>
          
          {/* 네 개의 메인 메뉴 버튼들 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', maxWidth: '500px', width: '100%' }}>
            <button onClick={fetchCheonanData} className="menu-btn">천안</button>
            <button onClick={() => alert("준비 중")} className="menu-btn">아산</button>
            <button onClick={() => alert("준비 중")} className="menu-btn">견적서</button>
            <button onClick={() => alert("준비 중")} className="menu-btn">매출</button>
          </div>
        </header>
      )}

      {/* 2. 천안 매물 데이터 조회 뷰 */}
      {view === "cheonan" && (
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <button onClick={() => setView("main")} style={{ padding: '10px 15px', background: '#7f8c8d', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>◀ 홈으로</button>
            <h2 style={{ color: '#2c3e50', margin: 0 }}>천안 매물 데이터 목록</h2>
            <button onClick={() => alert("준비 중")} style={{ padding: '10px 20px', background: '#2ecc71', color: '#fff', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer' }}>➕ 매물 추가</button>
          </div>
          {/* 🔍 [추가] 검색 필터 영역 상자 */}
          <div style={{ background: '#fff', padding: '15px 20px', borderRadius: '8px', marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#7f8c8d' }}>현장명</label>
              <select value={searchSite} onChange={(e) => setSearchSite(e.target.value)} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '160px' }}>
                <option value="">전체 현장</option>
                {uniqueSites.map(site => <option key={site} value={site}>{site}</option>)}
              </select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#7f8c8d' }}>담당자</label>
              <select value={searchManager} onChange={(e) => setSearchManager(e.target.value)} style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '130px' }}>
                <option value="">전체 담당자</option>
                {uniqueManagers.map(manager => <option key={manager} value={manager}>{manager}</option>)}
              </select>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#7f8c8d' }}>동</label>
              <input type="text" placeholder="예: 101동" value={searchDong} onChange={(e) => setSearchDong(e.target.value)} style={{ padding: '7px', borderRadius: '4px', border: '1px solid #ccc', width: '100px' }} />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <label style={{ fontSize: '0.85rem', fontWeight: 'bold', color: '#7f8c8d' }}>호수</label>
              <input type="text" placeholder="예: 1502" value={searchHo} onChange={(e) => setSearchHo(e.target.value)} style={{ padding: '7px', borderRadius: '4px', border: '1px solid #ccc', width: '100px' }} />
            </div>

            <button onClick={resetSearch} style={{ marginTop: '20px', padding: '8px 15px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>초기화</button>
            <span style={{ marginTop: '20px', marginLeft: 'auto', fontSize: '0.95rem', fontWeight: 'bold', color: '#34495e' }}>검색 결과: {filteredList.length}건</span>
          </div>

          {/* 스크롤 가능한 매물 테이블 판데기 */}
          <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', minWidth: '2000px' }}>
              <thead>
                <tr style={{ background: '#34495e', color: '#fff' }}>
                  <th style={{ padding: '12px' }}>번호</th>
                  <th style={{ padding: '12px' }}>현장명</th>
                  <th style={{ padding: '12px' }}>진행상태</th>
                  <th style={{ padding: '12px' }}>거래타입</th>
                  <th style={{ padding: '12px' }}>동</th>
                  <th style={{ padding: '12px' }}>호수</th>
                  <th style={{ padding: '12px' }}>타입</th>
                  <th style={{ padding: '12px' }}>방향</th>
                  <th style={{ padding: '12px' }}>프리미엄(만원)</th>
                  <th style={{ padding: '12px' }}>분양가(만원)</th>
                  <th style={{ padding: '12px' }}>확장비(만원)</th>
                  <th style={{ padding: '12px' }}>옵션비(만원)</th>
                  <th style={{ padding: '12px' }}>총 매매가(만원)</th>
                  <th style={{ padding: '12px' }}>옵션내역</th>
                  <th style={{ padding: '12px' }}>매물특징</th>
                  <th style={{ padding: '12px' }}>매도자성함</th>
                  <th style={{ padding: '12px' }}>연락처</th>
                  <th style={{ padding: '12px' }}>핸드폰번호</th>
                  <th style={{ padding: '12px' }}>통화날짜</th>
                  <th style={{ padding: '12px' }}>수수료작업</th>
                  <th style={{ padding: '12px' }}>담당자</th>
                </tr>
              </thead>
              <tbody>
                {filteredList.map((item, index) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid #ddd', backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                    <td style={{ padding: '12px' }}>{index + 1}</td>
                    <td style={{ padding: '12px', fontWeight: 'bold' }}>{item.siteName}</td>
                    <td style={{ padding: '12px' }}><span style={{
                       padding: '3px 8px',
                       borderRadius: '4px',
                       color: '#fff',
                       background: 
                        item.status === '보류' ? '#2ecc71' 
                        : item.status === '실거주' ? '#515251' 
                        : item.status === '광고중' ? '#f1c40f'
                        : item.status === '광고요청' ? '#a057d1'
                        : item.status === '거래완료' ? '#bfbec0'
                        : '#e74c3c' 
                       }}>{item.status}</span></td>
                    <td style={{ padding: '12px' }}>{item.tradeType}</td>
                    <td style={{ padding: '12px' }}>{item.dong}</td>
                    <td style={{ padding: '12px' }}>{item.ho}</td>
                    <td style={{ padding: '12px' }}>{item.type}</td>
                    <td style={{ padding: '12px' }}>{item.direction}</td>
                    <td style={{ padding: '12px', color: '#e74c3c', fontWeight: 'bold' }}>{item.premiumAmount?.toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{item.salePrice?.toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{item.expansionPrice?.toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{item.optionPrice?.toLocaleString()}</td>
                    <td style={{ padding: '12px', color: '#2c3e50', fontWeight: 'bold' }}>{item.totalPrice?.toLocaleString()}</td>
                    <td style={{ padding: '12px' }}>{item.optionDetails}</td>
                    <td style={{ padding: '12px' }}>{item.features}</td>
                    <td style={{ padding: '12px' }}>{item.sellerName}</td>
                    <td style={{ padding: '12px' }}>{item.contact}</td>
                    <td style={{ padding: '12px' }}>{item.phone}</td>
                    <td style={{ padding: '12px' }}>{item.callDate}</td>
                    <td style={{ padding: '12px' }}>{item.feeWork}</td>
                    <td style={{ padding: '12px' }}>{item.manager}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;